export default {
  methods: {
    // toCapitalize(str) {
    //   if (typeof str !== 'string') return ;
    //   str = str.toLowerCase();

    //   return str.replace(/\b\w/g, function(l){ return l.toUpperCase() })
    // },
    getCategory(sightMapType, category) {
      if (category.startsWith('macao-light-festival')) {
        return {
          name: this.$t('mlf.name'),
          to: '/macao-light-festival',
        }
      }
      
      switch (category) {
        case "suggested-tours":
          return {
            name: this.$t('trip.suggestedTour'),
            to: '/suggested-tours',
          }
        case "dining":
          return {
            name: this.$t('header.diningOut'),
            to: `/dining`
          }
          break;
        case "whatson":
          return {
            name: this.$t('enf.whatsOn'),
            to: `/whatson`
          }
          break;
        case "events":
          return {
            name: this.$t('enf.whatsOn'),
            to: `/whatson`
          }
          // return {
          //   name: this.$t('enf.enf'),
          //   to: `/events`
          // }
          break;
        case "accommodation":
          return {
            name: this.$t('header.accommodation'),
            to: `/accommodation`
          }
          break;
        
        case "travelessential":
          return {
            name: this.$t('header.travelessential'),
            to: `/travelessential`
          }
          break;

        case "whatson":
          return {
            name: this.$t('enf.whatsOn'),
            to: `/whatson`
          }
          break;

        case "blog":
          return {
            name: this.$t('followTheStar.followTheStar'),
            to: `/blog`
          }
          break;

        default:
          return {
            name: this.$store.getters['experience/getCategoryName'](
              this.$i18n.locale,
              category
            ),
            to: `/${category}`,
          }
          break;
      }
    },
    getGroup(sightMapType, category, group, groupName) {      
      return {
        name: groupName,
        to: `/${category}/${group}`
      }
    }
  }
}